import { atom } from "recoil";

export const activeTabSearchFromPageState = atom({
    key: 'activeTabSearchFromPage',
    default: "1"
})